import { FC, useEffect, useState } from 'react';

import { appSettings } from '@/settings/app-settings';
import { Business } from '@/ux-legacy/components/common/bentoboard/Common/board-types';
import { IMG_PLACEHOLDER } from '@/ux-legacy/uikit/utils/img-placeholder';

type VendorHeaderProps = {
  vendor: Business | null;
};

const VendorHeader: FC<VendorHeaderProps> = ({ vendor }) => {
  const [vendorDetails, setVendorDetails] = useState<Business | null>(vendor);
  // console.log(vendor)
  useEffect(() => {
    setVendorDetails(vendor);
  }, [vendor]);

  return (
    <>
      <div className="w-full h-auto flex flex-col items-center justify-center py-2">
        <img
          src={
            vendorDetails?.businessProfileImage
              ? appSettings.api.S3_MEDIA_COMPRESSED + vendorDetails?.businessProfileImage
              : IMG_PLACEHOLDER
          }
          className="w-[150px] h-[150px] rounded-full object-cover"
          alt="profile"
        ></img>

        <div className="mt-3 text-2xl font-bold">{vendorDetails?.businessName}</div>
        <div className="text-gray-500 dark:text-gray-400">{vendorDetails?.businessEmail}</div>
      </div>
    </>
  );
};

export default VendorHeader;
